/**
 * Detects if the current environment is a WebView
 * @returns boolean indicating if running in a WebView
 */
export function isWebView(): boolean {
  const ua = navigator.userAgent || "";
  const s = ua.toLowerCase();
  
  // Common WebView indicators
  return s.includes("wv") || 
         s.includes("webview") || 
         s.includes("androidwebview") ||
         s.includes("reactnativewebview") ||
         (s.includes("version/") && s.includes("mobile safari")) ||
         // Additional checks for various WebView implementations
         s.includes("fbav") || // Facebook WebView
         s.includes("fban") || // Facebook WebView
         s.includes("instagram") || // Instagram WebView
         s.includes("twitter") || // Twitter WebView
         s.includes("line/") || // Line WebView
         s.includes("micromessenger") || // WeChat WebView
         // Check for missing features that indicate WebView
         !window.chrome || // Chrome APIs not available
         (window as any).ReactNativeWebView !== undefined; // React Native WebView
}

/**
 * Detects if the current environment is likely a mobile device
 * @returns boolean indicating if running on mobile
 */
export function isMobile(): boolean {
  const ua = navigator.userAgent || "";
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

/**
 * Gets detailed information about the current environment
 * @returns object with environment details
 */
export function getEnvironmentInfo() {
  return {
    isWebView: isWebView(),
    isMobile: isMobile(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    vendor: navigator.vendor,
    hasChrome: !!(window as any).chrome,
    hasReactNativeWebView: !!(window as any).ReactNativeWebView,
    standalone: window.matchMedia('(display-mode: standalone)').matches
  };
}